import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import Page from '../../components/Page';
import Button from '../../components/Button';
import HaveQuestions from '../../components/HaveQuestions';
import Link from '../../components/Link';
import {useClearProductsFromCart} from "../../hooks/useClearProductsFromCart";
import styles from './style.module.scss';

const OrderAccepted = () => {
  // const [rating, setRating] = useState(4);
  const hasBeenAuth = !!Cookies.get('hermitage_user');
  const location = useLocation();
  const orderNumber = new URLSearchParams(location.search).get('order');
  const { handleClearProductsFromCart } = useClearProductsFromCart();

  const RequireAuth = () => (
    <>
      <div className={styles.SubTitle}>Зарегистрируйтесь, чтобы отслеживать Ваш заказ {"\n"} в приложении</div>
      <Link to='/auth'>
        <Button filled>
          Войти или зарегистрироваться
        </Button>
      </Link>
      <div className={styles.Container}>
        <HaveQuestions />
      </div>
    </>
  );

  // const HasBeenAuth = () => (
  //   <>
  //     <div className={styles.SubTitle}>Вы можете оставить отзыв</div>
  //     <div className={styles.Wrapper}>
  //       <div className={styles.Review}>
  //         <Input placeholder="Ваш отзыв..." />
  //         <div className={styles.Grade}>Ваша оценка</div>
  //         <div className={styles.Rating}>
  //           <Rating value={rating} onChange={setRating} />
  //         </div>
  //         <Button style={{ width: '100%', height: 48 }}>Отправить</Button>
  //       </div>
  //       <HaveQuestions />
  //     </div>
  //   </>
  // );

  useEffect(() => {
    handleClearProductsFromCart();
  }, []);

  return (
    <Page>
      <div className={styles.OrderAccepted}>
        <div className={styles.Title}>Заказ #{orderNumber} принят</div>
        {hasBeenAuth ? null : <RequireAuth />}
      </div>
    </Page>
  );
};

export default OrderAccepted;
